import styled from 'styled-components'

const StyledCountdownBanner = styled.div<{ isDiscount?: boolean }>`
  z-index: ${({ theme }) => theme.elevations.fixed};
  top: 0;
  display: flex;
  justify-content: center;
  background-color: ${({ theme, isDiscount }) =>
    (isDiscount ? theme.colors.green[400] : theme.colors.amber[200])};
  padding: 20px 34px;

  .banner-content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
  }

  .banner-text {
    margin-right: 0;
    padding-bottom: 10px;

    font-family: ${({ theme }) => theme.fonts.nunito};
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    color: ${({ theme, isDiscount }) =>
    (isDiscount ? theme.colors.gray[100] : theme.colors.gray[800])};
  }

  .learn-more-btn {
    color: ${({ theme, isDiscount }) =>
    (isDiscount ? theme.colors.green[400] : theme.colors.gray[50])};
    font-family: ${({ theme }) => theme.fonts.lexend};
    font-weight: 400;
    font-size: 14px;

    border: none;
    padding: 10px 20px;
    letter-spacing: 1px;
    background-color: ${({ theme, isDiscount }) => (isDiscount ? 'white' : theme.colors.gray[800])};
    border-radius: 3px;

    cursor: pointer;
  }

  @media (min-width: 1043px) {
    padding: 10px;

    .banner-content {
      flex-direction: row;
    }

    .banner-text {
      font-size: 16px;
      margin-right: 40px;
      padding-bottom: 0;
    }
  }
`

export default StyledCountdownBanner
